export default (func) => {
	setTimeout(func, 100);
};